// Production-grade error reporting. Dormant unless VITE_SENTRY_DSN is set.
import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export const sentryEnabled = Boolean(dsn);

export function initErrorReporting() {
  if (!sentryEnabled) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
  });

  // Chunk / preload failures
  window.addEventListener("vite:preloadError", (event: Event) => {
    const e = event as Event & { payload?: { message?: string }; target?: any };
    Sentry.captureMessage("vite:preloadError", {
      level: "error",
      extra: {
        message: e.payload?.message,
        target: (e.target as any)?.src ?? (e.target as any)?.href,
        path: window.location.pathname,
        userAgent: navigator.userAgent,
      },
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason: any = event.reason;
    const msg = reason?.message ?? String(reason);
    if (
      msg.includes("Importing a module script failed") ||
      msg.includes("Failed to fetch dynamically imported module") ||
      msg.includes("ChunkLoadError")
    ) {
      Sentry.captureException(reason ?? new Error(msg), {
        extra: { path: window.location.pathname, userAgent: navigator.userAgent },
      });
    }
  });
}

export const ErrorBoundary = Sentry.ErrorBoundary;
